'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCameraRoll = function MdCameraRoll(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.4 15v-3.4h-3.4v3.4h3.4z m0 15v-3.4h-3.4v3.4h3.4z m-6.8-15v-3.4h-3.2v3.4h3.2z m0 15v-3.4h-3.2v3.4h3.2z m-6.6-15v-3.4h-3.4v3.4h3.4z m0 15v-3.4h-3.4v3.4h3.4z m3.4-21.6h13.2v25h-13.2c0 1.8-1.6 3.2-3.4 3.2h-13.4c-1.8 0-3.2-1.4-3.2-3.2v-25c0-1.8 1.4-3.4 3.2-3.4h1.8v-1.6c0-1 0.7-1.8 1.6-1.8h6.6c1 0 1.8 0.8 1.8 1.8v1.6h1.6c1.8 0 3.4 1.6 3.4 3.4z' })
        )
    );
};

exports.default = MdCameraRoll;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/camera-roll.js
// module id = 562
// module chunks = 0